import { render, staticRenderFns } from "./DashboardItemWrapper.vue?vue&type=template&id=4742806c&scoped=true&"
import script from "./DashboardItemWrapper.vue?vue&type=script&lang=ts&"
export * from "./DashboardItemWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardItemWrapper.vue?vue&type=style&index=0&id=4742806c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742806c",
  null
  
)

export default component.exports